//import { Page } from "./model/Page";
import { InputElement, InputSingleValueNumber, InputSingleValueString, InputOptional, InputAction, InputType, InputValueBoolean, InputImage, InputUpload, UIElementHint } from "../model/Element";
import { getElementWithPagekey, createMailLink, Flow } from '../FlowEngineAPI';

import { downloadPDFGeneric } from '../../pdf/PDFCreator';
import { Page } from "../model/Page";


// multilanguage
import i18n from "../../../localization/i18n";

//
interface IHash {
    [key: string] : string;
} 

var translation_en: IHash = {
                    "CategoryCombination": "Category",
                    "CategoryDriving": "Driving",
                    "CategoryDriven": "Driven side",
                    "CategoryCoupling": "Coupling",
                    "CategoryOverview": "Overview",

                    "CombinationPageHeader": "Combination IC Engine and Driven side",
                    "CombinationHydraulics": "IC Engine + Hydraulicpump",
                    "CombinationWaterpump": "IC Engine + Waterpump",
                    "CombinationGenerator": "IC Engine + Generator",
                    "CombinationCompressor": "IC Engine + Compressor",
                    "CombinationCombinationMotorDriven": "Combination motor / driven side",

                    "MotortypeLabel": "Motor type",
                    "MotortypeSelection": "Motor",
                    "MotortypeOptionDiesel": "Diesel engine",
                    "MotortypeOptionGas": "Gas engine",
                    "MotortypeOptionBenzine": "Benzine engine",
                    "MotorType": "Engine design",
                    "MotorTypeSerial": "Serial",
                    "MotorTypeVMotor": "V-Motor",
            
                    "DieselData": "Data diesel engine",
                    "DieselManufacturer" : "Manufacturer",
                    "DieselType" : "Type",
                    "DieselNumCyl" : "Num of cylinders",
                    "DieselDataStroke2": "2 strokes",
                    "DieselDataStroke4": "4 strokes",
                    "DieselAngleVMotor" : "Angle V-motor",
                    "DieselMomentOfInertia" : "Moment of intertia",
                    "DieselMassReplacement" : "Upload mass replacement",

                    "OperationalPointDriving": "Operational point driving",
                    "OperationalPointDrivingNominalPower": "Nominal power",
                    "OperationalPointDrivingNominalTorque": "Nominal torque",
                    "OperationalPointDrivingNominalSpeed": "Nominal speed",
                    "OperationalPointDrivingNullSpeed": "Idle speed",
                    "OperationalPointDrivingOperation": "Operation",
                    "OperationalPointDrivingOperationFix": "Fix",
                    "OperationalPointDrivingOperationVariable": "Variable",
                    "OperationalPointDrivingMinSpeed": "Min. speed",
                    "OperationalPointDrivingMaxSpeed": "Max. speed",
                    
                    "Flywheel": "Flywheel",
                    "FlywheelAdapter": "Flywheeladapter",
                    "FlywheelCenterDiameter": "Dimension center diameter",
                    "FlywheelPitchCircle": "Dimension pitch circle",
                    "FlywheelMomentsOfInertia": "Moment of inertia",
                    
                    "Housing": "Housing",
                    "HousingSize": "Housing size acc. to SAE J617",
                    "HousingMassG": "G-Maß",
                    "HousingCouplingAssembly": "Coupling assembly",
                    
                    "GasmotorData": "Data Gasmotor",
                    "GasmotorDataManufacturer": "Manufacturer",
                    "GasmotorDataType": "Type",
                    "GasmotorDataNumCylinder": "Num. Cylinder",
                    "GasmotorDataStroke": "Stroke",
                    "GasmotorDataStroke2": "2-stroke",
                    "GasmotorDataStroke4": "4-stroke",
                    "GasmotorGasType": "Ga type",
                    "GasmotorDataMethan": "Methan",
                    "GasmotorDataNaturalGas": "Natural gas",
                    "GasmotorDataMomentsOfInertia": "Moment of inertia",
                    "GasmotorDataMassReplacementUpload": "Upload mass replacement",
                    
                    "BenzinemotorData": "Data Benzine motor",
                    "BenzinemotorDataManufacturer": "Maufacturer",
                    "BenzinemotorDataType": "Type",
                    "BenzinemotorDataNumCylinder": "Number of cylinder",
                    "BenzinemotorDataStroke": "Stroke",
                    "BenzinemotorDataStroke2": "2-stroke",
                    "BenzinemotorDataStroke4": "4-stroke",
                    "BenzinemotorDataMotorType": "Motorstyle",
                    "BenzinemotorDataSerial": "Serial",
                    "BenzinemotorDataVMotor": "V-Motor",
                    "BenzinemotorDataMomentsOfInertia": "Moment of inertia",
                    "BenzinemotorDataMassReplacementUpload": "Upload mass replacement",
                    
                    "HydraulicspumpData": "Data Hydraulic pump",
                    "HydraulicspumpDataNumPumps": "Number of Pumps",
                    "HydraulicspumpDataManufacturer": "Manufacturer",
                    "HydraulicspumpDataType": "Type",
                    "HydraulicspumpMomentsOfInertia1": "Moment of inertia pump 1",
                    "HydraulicspumpStiffness1": "Stiffness pump 1",
                    "HydraulicspumpMomentsOfInertia2": "Moment of inertia pump 2",
                    "HydraulicspumpStiffness2": "Stiffness pump 2",
                    "HydraulicspumpMomentsOfInertia3": "Moment of inertia pump 3",
                    "HydraulicspumpStiffness3": "Stiffness pump 3",
                    "HydraulicspumpMomentsOfInertia4": "Moment of inertia pump 4",
                    "HydraulicspumpStiffness4": "Stiffness pump 4",
                    
                    "OperationalPointHydraulics": "Operational point hydraulicmotor",
                    "OperationalPointPower": "Power",
                    "OperationalPointTorque": "Torque",
                    "OperationalPointSpeed": "Speed",
                    
                    "ShaftType": "Shaft type",
                    "ShaftTypeBoreType": "Shaft type",
                    "ShaftTypeCylindrical": "Cylindrical",
                    "ShaftTypeTaper": "Taper",
                    "ShaftTypeProfile": "Spline",
                    
                    "BoreCylindrical": "Bore cylindrical",
                    "BoreCylindricalNominalDiameter": "Diameter",
                    "BoreCylindricalLength": "Length of shaft",
                    "BoreCylindricalFeatherKeyway": "Keyway acc. to DIN 6885 Bl. 1",
                    "BoreCylindricalImage": "ImageCylindricalLength",
                    
                    "SizeFlange": "Flange",
                    "SizeFlangeSize": "Size flange nach SAE",
                    
                    "SizeHousing": "Housing",
                    "SizeHousingSize": "Size of housing",
                    
                    "FlangeType": "Flange type",
                    "FlangeTypeStyle": "Type of flange",
                    "FlangeTypeHoles2": "2-hole",
                    "FlangeTypeHoles4": "4-hole",
                    
                    "OtherRequirements": "Other",
                    "OtherRequirementsATEX": "ATEX",
                    "OtherRequirementsBalancing": "Balancing",
                    "OtherRequirementsConnPumpHousing": "Connection pump/motor-housing KTR",
                    "OtherRequirementsCertificate": "Initial inspection report",
                    "OtherRequirementsCertificateMaterial": "Material certificate",
                    "OtherRequirementsBalancingDetails": "Balancing details",
                    "OtherRequirementsOther": "Other",
                    
                    "BoreTaper": "Kegelbohrung",
                    "BoreTaperD1": "d1",
                    "BoreTaperD2": "d2",
                    "BoreTaperL1": "l1",
                    "BoreTaperL2": "l2",
                    "BoreTaperKeyway": "Keyway",
                    "BoreTaperType": "Taper",
                    "BoreTaperType15": "Taper 1:5",
                    "BoreTaperType18": "Taper 1:8",
                    
                    "BoreProfile": "Spline",
                    "BoreProfileNorm": "Spline norm",
                    "BoreProfileCode": "Spline code",
                    "BoreProfileLength": "Shaft length",
                    "BoreProfileImage": "ImageSplineLength",
                    
                    "WaterpumpData": "Daten Water pump",
                    "WaterpumpDataManufacturer": "Company",
                    "WaterpumpDataType": "Type",
                    "WaterpumpDataAdditionalDrives": "Additional drives ?",
                    "WaterpumpDataMomentOfInertia": "Moment of inertia",
                    "WaterpumpDataStiffness": "Stiffness",
                    "WaterpumpDataTypeSecondaryDrive": "Type secondary drive",
                    "WaterpumpDataMomentOfInertiaAdditionalDrive": "Moments of inertial additional drive",
                    "WaterpumpDataStiffnessAdditionalDrive": "Stiffness additional drive",
                    
                    "GeneratorData": "Data Generator",
                    "GeneratorDataManufacturer": "Manufacturer",
                    "GeneratorDataType": "Type",
                    "GeneratorDataMomentOfInertia": "Moment of inertia",
                    "GeneratorDataStiffness": "Stiffness",
                    
                    "OperationalPointGenerator": "Operational point generator",
                    "OperationalPointGeneratorPower": "Power",
                    "OperationalPointGeneratorTorque": "Torque",
                    "OperationalPointGeneratorSpeed": "Speed",
                    
                    "CompressorData": "Compressor",
                    "CompressorDataType": "Type",
                    "CompressorDataPiston": "Reciprocating compressor",
                    "CompressorDataScrew": "Screw compressor",
                    
                    "CompressorDataPistonData": "Reciprocating compressor",
                    "CompressorDataPistonDataManufacturer": "Manufacturer",
                    "CompressorDataPistonDataType": "Type",
                    
                    "OperationalPointCompressorPiston": "Operational point reciprocating compressor",
                    "OperationalPointCompressorPistonMomentOfInertia": "Moment of inertia",
                    "OperationalPointCompressorPistonStiffness": "Stiffness",
                    "OperationalPointCompressorPistonMassReplacementUpload": "Upload mass replacement",
                    "OperationalPointCompressorPistonNumCylinder": "Number of cylinder",
                    "OperationalPointCompressorPistonPosCylinder": "Position cylinder",
                    "OperationalPointCompressorPistonPosCylinderVertical": "Vertical",
                    "OperationalPointCompressorPistonPosCylinderHorizontal": "Horizontal",
                    "OperationalPointCompressorPistonPosCylinderV": "V-Type",
                    "OperationalPointCompressorPistonPosCylinderW": "W-Type",
                    "OperationalPointCompressorPistonPosCylinderL": "L-Type",
                    "OperationalPointCompressorPistonCompressionLevel": "Compression level",
                    "OperationalPointCompressorPistonUploadTangential": "Upload tangential force diagram",
                    
                    "CompressorDataScrewData": "Screw compressor",
                    "CompressorDataScrewDataManufacturer": "Manufacturer",
                    "CompressorDataScrewDataType": "Type",
                    "CompressorDataScrewDataGearbox": "Gearbox available ?",
                    "CompressorDataScrewDataTransmissionRatio": "Transmission ratio i",
                    
                    "OperationalPointCompressorScrew": "Operational point screw compressor",
                    "OperationalPointCompressorScrewMomentOfInertia": "Moment of inertia",
                    "OperationalPointCompressorScrewStiffness": "Stiffness",
                    "OperationalPointCompressorScrewUpladMassReplacement": "Upload mass replacement",
                    
                    "Contact": "Contact",
                    "ContactCompany": "Company",
                    "ContactAdress": "Adress",
                    "ContactName": "Name",
                    "ContactTelephone": "Telephone",
                    "ContactMail": "Mail",
                    "ContactUploadFiles": "Upload addtional files",
                    "ContactSendMail": "Send mail",
                    "ContactCreatePDF": "Create PDF",
                    
                }

var translation_de: IHash =  {
                    "CategoryCombination": "Kategorie",
                    "CategoryDriving": "Antrieb",
                    "CategoryDriven": "Lastseite",
                    "CategoryCoupling": "Kupplung",
                    "CategoryOverview": "Übersicht",

                    "CombinationPageHeader": "Kombination Verbrennungsmotor und Abtrieb",
                    "CombinationHydraulics": "Verbrennungsmotor + Hydraulikpumpe",
                    "CombinationWaterpump": "Verbrennungsmotor + Wasserpumpe",
                    "CombinationGenerator": "Verbrennungsmotor + Generator",
                    "CombinationCompressor": "Verbrennungsmotor + Verdichter",
                    "CombinationCombinationMotorDriven": "Kombination Motor Abtrieb",

                    "MotortypeLabel": "Motortyp",
                    "MotortypeSelection": "Motor",
                    "MotortypeOptionDiesel": "Dieselmotor",
                    "MotortypeOptionGas": "Gasmotor",
                    "MotortypeOptionBenzine": "Benzinmotor",
                    "MotorType": "Motorbauart",
                    "MotorTypeSerial": "Reihe",
                    "MotorTypeVMotor": "V-Motor",

                    "DieselData": "Daten Dieselmotor",
                    "DieselManufacturer" : "Hersteller",
                    "DieselType" : "Typ",
                    "DieselNumCyl" : "Anzahl Zylinder",
                    "DieselDataStroke2": "2-Takt",
                    "DieselDataStroke4": "4-Takt",
                    "DieselAngleVMotor" : "Angle V-motor",
                    "DieselMomentOfInertia" : "Moment of intertia",
                    "DieselMassReplacement" : "Massenersatzsystem hochladen",
                    
                    "OperationalPointDriving": "Betriebspunkt Antrieb",
                    "OperationalPointDrivingNominalPower": "Nennleistung",
                    "OperationalPointDrivingNominalTorque": "Nenndrehmoment",
                    "OperationalPointDrivingNominalSpeed": "Betriebsdrehzahl",
                    "OperationalPointDrivingNullSpeed": "Leerlaufdrehzahl",
                    "OperationalPointDrivingOperation": "Betrieb",
                    "OperationalPointDrivingOperationFix": "Fix",
                    "OperationalPointDrivingOperationVariable": "Variabel",
                    "OperationalPointDrivingMinSpeed": "Mindrehzahl",
                    "OperationalPointDrivingMaxSpeed": "Maxdrehzahl",

                    "Flywheel": "Schwungrad",
                    "FlywheelAdapter": "Schwungradanschluss",
                    "FlywheelCenterDiameter": "Sonderabmessung Zentrierdurchmesser",
                    "FlywheelPitchCircle": "Sonderabmessung Teilkreis",
                    "FlywheelMomentsOfInertia": "Massenträgheitsmoment",

                    "Housing": "Gehäuse",
                    "HousingSize": "Gehäusegröße nach SAE J617",
                    "HousingMassG": "G-Maß",
                    "HousingCouplingAssembly": "Kupplungseinbau",

                    "GasmotorData": "Daten Gasmotor",
                    "GasmotorDataManufacturer": "Hersteller",
                    "GasmotorDataType": "Typbezeichnung",
                    "GasmotorDataNumCylinder": "Anzahl Zylinder",
                    "GasmotorDataStroke": "Motortakt",
                    "GasmotorDataStroke2": "2-Takt",
                    "GasmotorDataStroke4": "4-Takt",
                    "GasmotorGasType": "Gasart",
                    "GasmotorDataMethan": "Methan",
                    "GasmotorDataNaturalGas": "Erdgas",
                    "GasmotorDataMomentsOfInertia": "Massenträgheitsmoment",
                    "GasmotorDataMassReplacementUpload": "Massenersatzsystem hochladen",

                    "BenzinemotorData": "Daten Benzinmotor",
                    "BenzinemotorDataManufacturer": "Hersteller",
                    "BenzinemotorDataType": "Typbezeichnung",
                    "BenzinemotorDataNumCylinder": "Anzahl Zylinder",
                    "BenzinemotorDataStroke": "Motortakt",
                    "BenzinemotorDataStroke2": "2-Takt",
                    "BenzinemotorDataStroke4": "4-Takt",
                    "BenzinemotorDataMotorType": "Motorbauart",
                    "BenzinemotorDataSerial": "Reihe",
                    "BenzinemotorDataVMotor": "V-Motor",
                    "BenzinemotorDataMomentsOfInertia": "Masseträgheitsmoment",
                    "BenzinemotorDataMassReplacementUpload": "Massenersatzsystem hochladen",

                    "HydraulicspumpData": "Daten Hydraulikpumpe",
                    "HydraulicspumpDataNumPumps": "Anzahl Pumpen",
                    "HydraulicspumpDataManufacturer": "Hersteller",
                    "HydraulicspumpDataType": "Typbezeichnung",
                    "HydraulicspumpMomentsOfInertia1": "Massenträgheitsmoment Pumpe 1",
                    "HydraulicspumpStiffness1": "Steifigkeit Pumpe 1",
                    "HydraulicspumpMomentsOfInertia2": "Massenträgheitsmoment Pumpe 2",
                    "HydraulicspumpStiffness2": "Steifigkeit Pumpe 2",
                    "HydraulicspumpMomentsOfInertia3": "Massenträgheitsmoment Pumpe 3",
                    "HydraulicspumpStiffness3": "Steifigkeit Pumpe 3",
                    "HydraulicspumpMomentsOfInertia4": "Massenträgheitsmoment Pumpe 4",
                    "HydraulicspumpStiffness4": "Steifigkeit Pumpe 4",

                    "OperationalPointHydraulics": "Betriebspunkt Hydraulikmotor",
                    "OperationalPointPower": "Leistung",
                    "OperationalPointTorque": "Drehmoment",
                    "OperationalPointSpeed": "Drehzahl",

                    "ShaftType": "Wellentyp",
                    "ShaftTypeBoreType": "Wellentyp",
                    "ShaftTypeCylindrical": "Zylindrisch",
                    "ShaftTypeTaper": "Kegel",
                    "ShaftTypeProfile": "Profil",

                    "BoreCylindrical": "Bohrung zylindrisch",
                    "BoreCylindricalNominalDiameter": "Nenndurchmesser",
                    "BoreCylindricalLength": "Wellenlänge",
                    "BoreCylindricalFeatherKeyway": "Passfeder nach DIN 6885 Bl. 1",
                    "BoreCylindricalImage": "ImageCylindricalLength",

                    "SizeFlange": "Flansch",
                    "SizeFlangeSize": "Größe Flanschanschluss nach SAE",

                    "SizeHousing": "Gehäuse",
                    "SizeHousingSize": "Gehäusegröße",

                    "FlangeType": "Flanschtyp",
                    "FlangeTypeStyle": "Ausführung Flanschanschluss",
                    "FlangeTypeHoles2": "2-Loch",
                    "FlangeTypeHoles4": "4-Loch",

                    "OtherRequirements": "Sonstiges",
                    "OtherRequirementsATEX": "ATEX",
                    "OtherRequirementsBalancing": "Wuchtung",
                    "OtherRequirementsConnPumpHousing": "Verbindung Pumpen/Motorgehäuse KTR",
                    "OtherRequirementsCertificate": "Erstmusterprüfbericht",
                    "OtherRequirementsCertificateMaterial": "Materialzeugnis",
                    "OtherRequirementsBalancingDetails": "Details zur Wuchtung (Wuchtgüte etc.)",
                    "OtherRequirementsOther": "Sonstiges",

                    "BoreTaper": "Kegelbohrung",
                    "BoreTaperD1": "d1",
                    "BoreTaperD2": "d2",
                    "BoreTaperL1": "l1",
                    "BoreTaperL2": "l2",
                    "BoreTaperKeyway": "Passfeder",
                    "BoreTaperType": "Kegel",
                    "BoreTaperType15": "Taper 1:5",
                    "BoreTaperType18": "Taper 1:8",

                    "BoreProfile": "Profilbohrung",
                    "BoreProfileNorm": "Profilnorm",
                    "BoreProfileCode": "ProfilCode",
                    "BoreProfileLength": "Wellenlänge",
                    "BoreProfileImage": "ImageSplineLength",

                    "WaterpumpData": "Daten Wasserpumpe",
                    "WaterpumpDataManufacturer": "Hersteller",
                    "WaterpumpDataType": "Typ",
                    "WaterpumpDataAdditionalDrives": "Weitere Antriebe (z.B. Riemenabtrieb) ?",
                    "WaterpumpDataMomentOfInertia": "Massenträgheitsmoment",
                    "WaterpumpDataStiffness": "Steifigkeit",
                    "WaterpumpDataTypeSecondaryDrive": "Typ Nebenantrieb",
                    "WaterpumpDataMomentOfInertiaAdditionalDrive": "Massenträgheitsmoment Zusatzabtrieb",
                    "WaterpumpDataStiffnessAdditionalDrive": "Steifigkeit Zusatzabtrieb",

                    "GeneratorData": "Daten Generator",
                    "GeneratorDataManufacturer": "Hersteller",
                    "GeneratorDataType": "Typ",
                    "GeneratorDataMomentOfInertia": "Massenträgheitsmoment",
                    "GeneratorDataStiffness": "Steifigkeit",

                    "OperationalPointGenerator": "BetriebspunktGenerator",
                    "OperationalPointGeneratorPower": "Leistung",
                    "OperationalPointGeneratorTorque": "Drehmoment",
                    "OperationalPointGeneratorSpeed": "Betriebsdrehzahl",

                    "CompressorData": "Verdichter",
                    "CompressorDataType": "Typ",
                    "CompressorDataPiston": "Hubkolbenkompressor",
                    "CompressorDataScrew": "Schraubenkompressor",

                    "CompressorDataPistonData": "Hubkolbenkompressor",
                    "CompressorDataPistonDataManufacturer": "Hersteller",
                    "CompressorDataPistonDataType": "Typ",

                    "OperationalPointCompressorPiston": "Betriebspunkt Hubkolbenkompressor",
                    "OperationalPointCompressorPistonMomentOfInertia": "Massenträgheitsmoment",
                    "OperationalPointCompressorPistonStiffness": "Steifigkeit",
                    "OperationalPointCompressorPistonMassReplacementUpload": "Massenersatzsystem hochladen",
                    "OperationalPointCompressorPistonNumCylinder": "Zylinderanzahl",
                    "OperationalPointCompressorPistonPosCylinder": "Zylinderanordnung",
                    "OperationalPointCompressorPistonPosCylinderVertical": "Vertikal",
                    "OperationalPointCompressorPistonPosCylinderHorizontal": "Horizontal",
                    "OperationalPointCompressorPistonPosCylinderV": "V-Bauart",
                    "OperationalPointCompressorPistonPosCylinderW": "W-Bauart",
                    "OperationalPointCompressorPistonPosCylinderL": "L-Bauart",
                    "OperationalPointCompressorPistonCompressionLevel": "Verdichtungsstufen",
                    "OperationalPointCompressorPistonUploadTangential": "Upload Tangentialkraftdiagramm",

                    "CompressorDataScrewData": "Schraubenkompressor",
                    "CompressorDataScrewDataManufacturer": "Hersteller",
                    "CompressorDataScrewDataType": "Typ",
                    "CompressorDataScrewDataGearbox": "Getriebestufe vorhanden ?",
                    "CompressorDataScrewDataTransmissionRatio": "Übersetzung i",

                    "OperationalPointCompressorScrew": "Betriebspunkt Schraubenkompressor",
                    "OperationalPointCompressorScrewMomentOfInertia": "Massenträgheitsmoment",
                    "OperationalPointCompressorScrewStiffness": "Steifigkeit",
                    "OperationalPointCompressorScrewUpladMassReplacement": "Massenersatzsystem hochladen",

                    "Contact": "Kontakt",
                    "ContactCompany": "Firma",
                    "ContactAdress": "Anschrift",
                    "ContactName": "Name",
                    "ContactTelephone": "Telefon",
                    "ContactMail": "Mail",
                    "ContactUploadFiles": "Weitere Dateien hochladen",
                    "ContactSendMail": "Mail verschicken",
                    "ContactCreatePDF": "PDF erstellen",

                    
                }

//var lang: string = "en";
var lang: string = i18n.language;
export function setLang(code: string) {
    //i18n.changeLanguage(code);
    lang = code;
    //let tmplang: string = i18n.language;
    //console.log(tmplang);
}

export function getLang(): string {
    //return i18n.language;
    return lang;
}

function tl(code: string): string {
    let res: string;
    if(lang === "de") {
    //if(i18n.language === "de") {
        res = translation_de[code] as string;
    }
    else {
        res = translation_en[code] as string;
    }
    return res;
}

// ==============================================================================================================================
//export interface Flow {
//    Pages: Page[]//
//}

// ==============================================================================================================================
// Globally usable functions/macros in the flow structure:
function macroGenerateProfileCodes(elvalue: string): string[] {
    //let el: InputElement | undefined = getElementWithPagekey("page16", "Profilnorm");
    //if(el === undefined)
    //    return [];
    if(elvalue === "DIN 5480") {
        return [
            "20x1,25x14x7H (d=20 mm)", "25x1,25x18x7H (d=25 mm)", "30x2x14x7H (d=30 mm)", "30x2x14x8H (d=30 mm)", "32x2x14x8H (d=32 mm)", "32x2x14x7H (d=32 mm)", 
            "35x2x16x8H (d=35 mm)", "40x2x18x7H (d=40 mm)", "40x2x18x8H (d=40 mm)", "45x2x21x7H (d=45 mm)", "50x1,25x38x8H (d=50 mm)", 
            "50x2x24x8H (d=50 mm)", "55x2x26x9H (d=55 mm)", "55x2x26x7H (d=55 mm)", "60x2x28x8H (d=60 mm)", "62x1,25x48x7H (d=62 mm)", 
            "70x3x22x8H (d=70 mm)", "70x3x22x7H (d=70 mm)", "80x3x25x7H (d=80 mm)", "80x3x25x8H (d=80 mm)", "90x3x28x7H (d=90 mm)", "100x3x32x8H (d=100 mm)"
        ];
    }
    else if(elvalue === "DIN 5482") {
        return [
            "17x14 z=9 (d=17 mm)", "28x25 z=15 (d=28 mm)", "30x27 z=16 (d=30 mm)", "35x31 z=18 (d=35 mm)", "40x36 z=20 (d=40 mm)", "45x41 z=22 (d=45 mm)", "50x45 z=24 (d=50 mm)"
        ];
    }
    if(elvalue === "DIN ISO 14") {
        return [
            "6x11x14 (d=11 mm)", 
            "6x18x22 (d=18 mm)", 
            "6x23x28 (d=23 mm)", 
            "6x28x34 (d=28 mm)", 
            "8x32x36 (d=32 mm)"
        ];
    }
    if(elvalue === "ANSI B92.1") {
        return [
            "16/32 pitch z=9 Code PH-S (d=16.5354 mm)"  ,
            "16/32 pitch z=11 Code PI-S (d=19.7104 mm)" , 
            "16/32 pitch z=13 Code PB-S (d=22.8854 mm)" , 
            "16/32 pitch z=15 Code PB-BS (d=26.0604 mm)", 
            "12/24 pitch z=14 Code PC-S (d=32.5882 mm)" , 
            "16/32 pitch z=21 Code PA-S (d=35.5854 mm)" , 
            "16/32 pitch z=23 Code PD-S (d=38.7604 mm)" , 
            "12/24 pitch z=17 Code PS-S (d=38.9382 mm)" , 
            "16/32 pitch z=27 Code PE-S (d=45.1104 mm)" , 
            "8/16 pitch z=13 Code PK (d=45.6692 mm)"    , 
            "8/16 pitch z=15 Code PT-C (d=52.0192 mm)"  , 
            "8/16 pitch z=17 Code PQ-C (d=58.3692 mm)"  , 
            "16/32 pitch z=40 Code PF (d=65.7352 mm)"
        ];
    }

    return [];
};


// ==============================================================================================================================
let globals = {
    title: "Verbrennungsmotor-Auslegung",
    namePDF: "ICEngineSelection"
}

// ==============================================================================================================================
let flow: Flow = {
    name: "icengine",
    label: "icengine-selection",
    Pages: [
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page1",
            name: "Kombination",
            //label: "Kombination Verbrennungsmotor und Abtrieb",
            //label: i18n.t('Combination'),
            label: tl('CombinationPageHeader'),
            url: "www.ktrpage.com/page1",
            isSelected: false,
            category: tl('CategoryCombination'),
            elements: [
                new InputOptional({
                    type: InputType.Optional,
                    name: "Kombination",
                    label: tl("CombinationCombinationMotorDriven"),
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.SelectCard,
                    assets: [
                        "Hydraulicspump",
                        "Waterpump",
                        "Generator",
                        "Compressor"
                    ],
                    options: [
                        tl("CombinationHydraulics"),
                        tl("CombinationWaterpump"),
                        tl("CombinationGenerator"),
                        tl("CombinationCompressor")
                    ],
                }),
            ],
            // decide if we can leave this page or not:
            isValid: () => { 
                return { res: true, msg: "" };
            },
            // select based on input the next page
            nextResolver: () => { 
                let nextPage: string = "page1a";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page1a",
            name: "Motortyp",
            label: tl('MotortypeLabel'),
            url: "www.ktrpage.com/page1",
            isSelected: false,
            category: tl('CategoryDriving'),
            elements: [
                new InputOptional({
                    type: InputType.Optional,
                    name: "Motorauswahl",
                    label: tl('MotortypeSelection'),
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.SelectCard,
                    assets: [
                        "Dieselmotor",
                        "Gasmotor",
                        "Benzinmotor"
                    ],
                    options: [
                        tl("MotortypeOptionDiesel"),
                        tl("MotortypeOptionGas"),
                        tl("MotortypeOptionBenzine")
                    ],
                }),
            ],
            // decide if we can leave this page or not:
            isValid: () => { 
                return { res: true, msg: "" };
            },
            // select based on input the next page
            nextResolver: () => { 
                let nextPage: string = "";
                let el: InputElement | undefined = getElementWithPagekey("page1a", "Motorauswahl");
                if(el !== undefined) {
                    if(el.value === 0) nextPage = "page2"
                    else if(el.value === 1) nextPage = "page6"
                    else if(el.value === 2) nextPage = "page7"
                }
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page2",
            name: "Daten Dieselmotor",
            label: tl("DieselData"),
            url: "www.ktrpage.com/page2",
            isSelected: false,
            category: tl('CategoryDriving'),
            elements: [
                new InputOptional({
                    type: InputType.Optional,
                    name: "Hersteller",
                    label: tl("DieselManufacturer"),
                    value: 0,
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Combobox,
                    options: ["Nissan","Perkins","Cummins","John Deere","Detroit","Deutz","Farymann","Hatz","Honda","Isuzu","Komatsu","Kubota","Lister Petter","Lombardini/Kohler","Renault",
                              "VM-Motori","MAN","DB","Caterpillar","Mitsubishi","Volvo","VW","Iveco","Yanmar","Deawo","Weifang","Koel","Hino","Scania","JCB","Scania","Clarke","MTU","Kamaz",
                              "Kirloskar","Liebherr","MWM"]
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Typbezeichnung",
                    label: tl("DieselType"),
                    value: "",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Anzahl_Zylinder",
                    label: tl("DieselNumCyl"),
                    value: 4,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputOptional({
                    type: InputType.Optional,
                    name: "Motortakt",
                    label: tl("DieselStroke"),
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options: [tl("DieselDataStroke2"), tl("DieselDataStroke4")]
                }),
                new InputOptional({
                    type: InputType.Optional,
                    name: "Motorbauart",
                    label: tl("MotorType"),
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options: [tl("MotorTypeSerial"), tl("MotorTypeVMotor")]
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Winkel-V-Motor",
                    label: tl("DieselAngleVMotor"),
                    value: "",
                    unit: "°",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputElement | undefined = getElementWithPagekey("page2", "Motorbauart");
                        if(el !== undefined) {
                            if(el.value === 1)    // only when V-Motor
                                return true;
                            else
                                return false;
                        }
                        else
                            return false;
                    }
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Masseträgheitsmoment",
                    label: tl("DieselMomentOfInertia"),
                    value: undefined,
                    unit: "kg*m²",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),

                /*
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Massenersatzsystem",
                    label: "Massenersatzsystem",
                    value: "",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputElement | undefined = getElementWithPagekey("page2", "Masseträgheitsmoment");
                        if(el !== undefined) {
                            if(el.value !== "")    // only Diesel and Benzin are assumed to have a cat
                                return true;
                            else
                                return false;
                        }
                        else
                            return false;
                    }
                }),
                */

                new InputUpload({
                    type: InputType.Upload,
                    name: "Massenersatzsystem",
                    label: tl("DieselMassReplacement"),
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputElement | undefined = getElementWithPagekey("page2", "Masseträgheitsmoment");
                        if(el !== undefined) {
                            if(el.value !== "")    // only Diesel and Benzin are assumed to have a cat
                                return true;
                            else
                                return false;
                        }
                        else
                            return false;
                    }
                }),

            ],
            isValid: () => { 
                //let p: Page | undefined = getElementWithPagekey("page2", "Masseträgheitsmoment");
                return { res: true, msg: "" };
            },
            nextResolver: () => { 
                let nextPage: string = "page3";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page3",
            name: "Kenndaten Betriebspunkt Antrieb",
            label: tl("OperationalPointDriving"),
            url: "www.ktrpage.com/page3",
            isSelected:  false,
            category: tl('CategoryDriving'),
            elements: [
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Nennleistung",
                    label: tl("OperationalPointDrivingNominalPower"),
                    value: undefined,
                    unit: "kW",
                    minValue: 0,
                    maxValue: 100000,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isValid: () => { 
                        let ret: boolean = true;

                        let me: any = getElementWithPagekey("page3", "Nennleistung");
                        if(me === undefined)
                            return false;

                        if(me.value === "") return true;
                        if(me.minValue === undefined) return true;
                        if(me.maxValue === undefined) return true;

                        let numv = Number(me.value);
                        let nummin = Number(me.minValue);
                        let nummax = Number(me.maxValue);

                        if((nummin !== undefined) && (numv < nummin)) ret = false;
                        if((nummax !== undefined) && (numv > nummax)) ret = false;

                        return ret;
                    },
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Nenndrehmoment",
                    label: tl("OperationalPointDrivingNominalTorque"),
                    value: undefined,
                    unit: "Nm",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Betriebsdrehzahl",
                    label: tl("OperationalPointDrivingNominalSpeed"),
                    value: undefined,
                    unit: "1/min",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "LeerlaufdrehzahlNumber",
                    label: tl("OperationalPointDrivingNullSpeed"),
                    value: undefined,
                    unit: "1/min",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputOptional({
                    type: InputType.Optional,
                    name: "Betrieb",
                    label: tl("OperationalPointDrivingOperation"),
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options: [tl("OperationalPointDrivingOperationFix"), tl("OperationalPointDrivingOperationVariable")]

                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Mindrehzahl",
                    label: tl("OperationalPointDrivingMinSpeed"),
                    value: undefined,
                    unit: "1/min",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputElement | undefined = getElementWithPagekey("page3", "Betrieb");
                        if(el !== undefined) {
                            if(el.value === 1)
                                return true;
                            else
                                return false;
                        }
                        else
                            return false;
                    }
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Maxdrehzahl",
                    label: tl("OperationalPointDrivingMaxSpeed"),
                    value: undefined,
                    unit: "1/min",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputElement | undefined = getElementWithPagekey("page3", "Betrieb");
                        if(el !== undefined) {
                            if(el.value === 1)
                                return true;
                            else
                                return false;
                        }
                        else
                            return false;
                    }
                })
            ],
            nextResolver: () => { 
                let nextPage: string = "page4";
                return nextPage;
            }            
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page4",
            name: "Schwungradanschluss",
            label: tl("Flywheel"),
            url: "www.ktrpage.com/page4",
            isSelected: false,
            category: tl('CategoryDriving'),
            elements: [
                new InputOptional({
                    type: InputType.Optional,
                    name: "Schwungradanschluss",
                    label: tl("FlywheelAdapter"),
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Dropdown,
                    options: ["Extra", "SAE 6.5", "SAE 7.5", "SAE 8", "SAE 10", "SAE 11.5", "SAE 14", "SAE 16", "SAE 18", "SAE 21", "SAE 24"]
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "SonderabmessungZentrierdurchmesser",
                    label: tl("FlywheelCenterDiameter"),
                    value: undefined,
                    unit: "mm",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputElement | undefined = getElementWithPagekey("page4", "Schwungradanschluss");
                        if(el !== undefined) {
                            if(el.value === 0)  // 0 == Sonder
                                return true;
                            else
                                return false;
                        }
                        else
                            return false;
                    }
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "SonderabmessungTeilkreis",
                    label: tl("FlywheelPitchCircle"),
                    value: undefined,
                    unit: "mm",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputElement | undefined = getElementWithPagekey("page4", "Schwungradanschluss");
                        if(el !== undefined) {
                            if(el.value === 0)  // 0 == Sonder
                                return true;
                            else
                                return false;
                        }
                        else
                            return false;
                    }
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Masseträgheitsmoment",
                    label: tl("FlywheelMomentsOfInertia"),
                    value: undefined,
                    unit: "kg*m²",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                })
            ],
            nextResolver: () => { 
                let nextPage: string = "page5";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page5",
            name: "Gehäusegrösse",
            label: tl("Housing"),
            url: "www.ktrpage.com/page5",
            isSelected: false,
            category: tl('CategoryDriving'),
            elements: [
                new InputOptional({
                    type: InputType.Optional,
                    name: "Gehäusegröße",
                    label: tl("HousingSize"),
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Dropdown,
                    options: ["SAE-1", "SAE-2", "SAE-3", "SAE-4", "SAE-5", "SAE-6" ]
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "G-Maß",
                    label: tl("HousingMassG"),
                    value: undefined,
                    unit: "mm",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputImage({
                    type: InputType.Image,
                    name: "CouplingAssembly",
                    label: tl("HousingCouplingAssembly"),
                    value: "",
                    target: "CouplingAssembly",         // takes image in public/images/wellen.jpg
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any
                }),

            ],

            nextResolver: () => { 
                let nextPage: string = "";
                let el: InputElement | undefined = getElementWithPagekey("page1", "Kombination");
                if(el !== undefined) {
                    if(el.value === 0) nextPage = "page8"
                    else if(el.value === 1) nextPage = "page17"
                    else if(el.value === 2) nextPage = "page18"
                    else if(el.value === 3) nextPage = "page20"
                }
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page6",
            name: "Daten_Gasmotor",
            label: tl("GasmotorData"),
            url: "www.ktrpage.com/page6",
            isSelected: false,
            category: tl('CategoryDriving'),
            elements: [
                /*
                new InputOptional({
                    type: InputType.Optional,
                    name: "Hersteller",
                    label: "Hersteller",
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Combobox,
                    options: ["Gasmotorfabrik1","Gasmotorfabrik2", "Gasmotorfabrik3", "Gasmotorfabrik4"]
                }),
                */
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Hersteller",
                    label: tl("GasmotorDataManufacturer"),
                    value: "",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),

                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Typbezeichnung",
                    label: tl("GasmotorDataType"),
                    value: "",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Anzahl_Zylinder",
                    label: tl("GasmotorDataNumCylinder"),
                    value: 4,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputOptional({
                    type: InputType.Optional,
                    name: "Motortakt",
                    label: tl("GasmotorDataStroke"),
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Dropdown,
                    options: [tl("GasmotorDataStroke2"), tl("GasmotorDataStroke4")]
                }),
                new InputOptional({
                    type: InputType.Optional,
                    name: "Gasart",
                    label: tl("GasmotorGasType"),
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Dropdown,
                    options: [tl("GasmotorDataMethan"), tl("GasmotorDataNaturalGas")]
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Masseträgheitsmoment",
                    label: tl("GasmotorDataMomentsOfInertia"),
                    value: undefined,
                    isMandatory:  false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                /*
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Massenersatzsystem",
                    label: "Massenersatzsystem",
                    value: "",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputElement | undefined = getElementWithPagekey("page6", "Masseträgheitsmoment");  // if box Masseträgheitsmoment is filled: show this element
                        if(el !== undefined) {
                            if(el.value !== "")
                                return true;
                            else
                                return false;
                        }
                        else
                            return false;
                    }
                })
                */
                new InputUpload({
                    type: InputType.Upload,
                    name: "Massenersatzsystem",
                    label: tl("GasmotorDataMassReplacementUpload"),
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputElement | undefined = getElementWithPagekey("page6", "Masseträgheitsmoment");
                        if(el !== undefined) {
                            if(el.value !== "")    // only Diesel and Benzin are assumed to have a cat
                                return true;
                            else
                                return false;
                        }
                        else
                            return false;
                    }
                }),
    
            ],
            nextResolver: () => { 
                let nextPage: string = "page3";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page7",
            name: "Daten Benzinmotor",
            label: tl("BenzinemotorData"),
            url: "www.ktrpage.com/page7",
            isSelected: false,
            category: tl('CategoryDriving'),
            elements: [
                /*
                new InputOptional({
                    type: InputType.Optional,
                    name: "Hersteller",
                    label: "Hersteller",
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Combobox,
                    options: ["Benziner1","Benziner2", "Benziner3"]
                }),
                */
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Hersteller",
                    label: tl("BenzinemotorDataManufacturer"),
                    value: "",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Typbezeichnung",
                    label: tl("BenzinemotorDataType"),
                    value: "",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Anzahl_Zylinder",
                    label: tl("BenzinemotorDataNumCylinder"),
                    value: 4,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputOptional({
                    type: InputType.Optional,
                    name: "Motortakt",
                    label: tl("BenzinemotorDataStroke"),
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Dropdown,
                    options: [tl("BenzinemotorDataStroke2"), tl("BenzinemotorDataStroke4")]   // 2-Takt, 4-Takt
                }),
                new InputOptional({
                    type: InputType.Optional,
                    name: "Motorbauart",
                    label: tl("BenzinemotorDataMotorType"),
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Dropdown,
                    options: [tl("BenzinemotorDataSerial"), tl("BenzinemotorDataVMotor")]             // Reihe, V-Motor
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Masseträgheitsmoment",
                    label: tl("BenzinemotorDataMomentsOfInertia"),
                    value: undefined,
                    isMandatory:  false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                /*
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Massenersatzsystem",
                    label: "Massenersatzsystem",
                    value: "",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputElement | undefined = getElementWithPagekey("page7", "Masseträgheitsmoment");  // if box Masseträgheitsmoment is filled: show this element
                        if(el !== undefined) {
                            if(el.value !== "")
                                return true;
                            else
                                return false;
                        }
                        else
                            return false;
                    }
                }),
                */
                new InputUpload({
                    type: InputType.Upload,
                    name: "Massenersatzsystem",
                    label: tl("BenzinemotorDataMassReplacementUpload"),
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputElement | undefined = getElementWithPagekey("page7", "Masseträgheitsmoment");
                        if(el !== undefined) {
                            if(el.value !== "")    // only Diesel and Benzin are assumed to have a cat
                                return true;
                            else
                                return false;
                        }
                        else
                            return false;
                    }
                }),
    
            ],
            nextResolver: () => { 
                let nextPage: string = "page3";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        // ABTRIEB


        /*
        new Page({
            id: "page8a",
            name: "Gerät_am_Abtrieb",
            label: "Abtriebsgerät",
            url: "www.ktrpage.com/page8a",
            isSelected: false,
            category: "Lastseite",
            elements: [
                new InputOptional({
                    type: InputType.Optional,
                    name:  "Pumpentyp",
                    label:  "Pumpentyp",
                    value: 0,
                    isMandatory:  true,
                    componentname:  "",
                    uiElementHint:  UIElementHint.SelectCard,
                    options:  [
                        "Hydraulikpumpe",
                        "Wasserpumpe",
                        "Generator", 
                        "Verdichter"                        
                    ],
                    //onAction: () => {
                    //    // Synchronize Optional "Motorauswahl" when clicking here
                    //    let elSource: InputOptional | undefined = (getElementWithPagekey("page8a", "Pumpentyp") as InputOptional);
                    //    let elTarget: InputOptional | undefined = (getElementWithPagekey("page8a", "PumpentypSimple") as InputOptional);
                    //    if((elSource === undefined) || (elTarget === undefined)) return;
                    //    elTarget.value =  elSource.value;
                    //}
                }),
            ],
            nextResolver: () => { 
                let nextPage: string = "";
                let el: InputElement | undefined = getElementWithPagekey("page8a", "Pumpentyp");
                if(el !== undefined) {
                    if(el.value === "Hydraulikpumpe") nextPage = "page8"
                    else if(el.value === "Wasserpumpe") nextPage = "page17"
                    else if(el.value === "Generator") nextPage = "page18"
                    else if(el.value === "Verdichter") nextPage = "page20"
                }
                return nextPage;
            }
        }),
        */

        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page8",
            name: "Daten_Hydraulikpumpe",
            label: tl("HydraulicspumpData"),
            url: "www.ktrpage.com/page8",
            isSelected: false,
            category: tl('CategoryDriven'),
            elements: [
                new InputOptional({
                    type: InputType.Optional,
                    name: "Anzahl_Pumpen",
                    label: tl("HydraulicspumpDataNumPumps"),
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options: ["1", "2", "3", "4"]
                }),
                new InputOptional({
                    type: InputType.Optional,
                    name: "Hersteller",
                    label: tl("HydraulicspumpDataManufacturer"),
                    value: 0,
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Combobox,
                    options: [
                        "ALLWEILER", "ATOS", "BARNES J.S. - HALDEX", "BEINLICH & HORNSCHEIDT", "BEKA (BAIER + KOEPPEL)", "BERARMA", 
                        "BIERI", "BOEHRINGER - HYDROKRAFT", "BORNEMANN  ", "BOSCH REXROTH AG", "BRINKMANN PUMPEN", "BUCHER (TRUNINGER)", 
                        "BURRE", "CAMEL HYDRAULIK-PUMPEN", "CASAPPA", "CLAAS INDUSTRIETECHNIK", "COMMERCIAL", "DANFOSS", "DAVID BROWN HYDRAULICS", 
                        "DENISON", "DUESTERLOH", "DYNEX - HYDRAULIK PUMPEN", "EATON ", "ECKERLE HYDRAULIK DIV.", "ECKERLE-REXROTH", 
                        "FAG", "HAWE", "HOVEN", "HYDAC", "HYDRAULIK - RING", "HYDROMOBIL - REICO", "HYDROPA", "HYDROPERFECT INTERN.-HPI", 
                        "IMO - PUMPEN ", "INTEGRAL - HYDRAULIK", "KARSTEN", "KAWASAKI HEAVY INDUSTRIES", "KNOLL MASCHINENBAU", "KRACHT", 
                        "KRAL - PUMPEN", "KRAUS&WIMMER", "LAMBORGHINI", "LEDUC", "LEISTRITZ - PUMPEN", "LINDE HYDRAULICS", "LUKRA  Lutz Kracht", 
                        "MARZOCCHI", "MOOG GmbH", "NACHI", "OILGEAR", "OLEODINAMICA", "PARKER - HANNIFIN", "PROCON PUMPEN - STANDEX", 
                        "PUTZIN PUMPEN", "RACINE", "REXROTH", "RHL - HYDRAULIK - RENOLD", "RICKMEIER - WERDOHLER", "ROQUET", "SACHSENHYDRAULIK - ORSTA", 
                        "SAE PUMPEN ANSCHL. J744", "SALAMI", "SAMHYDRAULIK (BREVINI)", "SAUER", "SAUER BIBUS (DAIKIN)", "SEIM - SCREW PUMPS", 
                        "SETTIMA MECCANICA", "STEIMEL", "SUNFAB", "TDZ Hidraulica (Spanien)", "TRIK - PUMPEN", "TUROLLA / SAUER DANFOSS", 
                        "ULTRA - HYDRAULIK (DOWTY)", "UNIVERSAL HYDRAULIK", "VAN DINTHER", "VICKERS", "VIVOIL ITALIEN", "VOAC HYDRAULICS (VOLVO)", 
                        "VOITH", "WESER PUMPEN", "WIMMER", "YUKEN"
                        ],
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Typbezeichnung",
                    label: tl("HydraulicspumpDataType"),
                    value: "",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Masseträgheitsmoment_Pumpe_1",
                    label: tl("HydraulicspumpMomentsOfInertia1"),
                    value: undefined,
                    unit: "kg*m²",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => {
                        let el: InputElement | undefined = getElementWithPagekey("page8", "Anzahl_Pumpen");
                        let elnum = (el !== undefined ? Number(el.getValue()) : 0);
                        if(elnum > 0)
                            return true;
                        else
                            return false;
                    }
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Steifigkeit_Pumpe_1",
                    label: tl("HydraulicspumpStiffness1"),
                    value: undefined,
                    unit: "Nm/rad",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => {
                        let el: InputElement | undefined = getElementWithPagekey("page8", "Anzahl_Pumpen");
                        let elnum = (el !== undefined ? Number(el.getValue()) : 0);
                        if(elnum > 0)
                            return true;
                        else
                            return false;
                    }
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Masseträgheitsmoment_Pumpe_2",
                    label: tl("HydraulicspumpMomentsOfInertia2"),
                    value: undefined,
                    unit: "kg*m²",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => {
                        let el: InputElement | undefined = getElementWithPagekey("page8", "Anzahl_Pumpen");
                        let elnum = (el !== undefined ? Number(el.getValue()) : 0);
                        if(elnum > 1)
                            return true;
                        else
                            return false;
                    }
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Steifigkeit_Pumpe_2",
                    label: tl("HydraulicspumpStiffness2"),
                    value: undefined,
                    unit: "Nm/rad",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => {
                        let el: InputElement | undefined = getElementWithPagekey("page8", "Anzahl_Pumpen");
                        let elnum = (el !== undefined ? Number(el.getValue()) : 0);
                        if(elnum > 1)
                            return true;
                        else
                            return false;
                    }
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Masseträgheitsmoment_Pumpe_3",
                    label: tl("HydraulicspumpMomentsOfInertia"),
                    value: undefined,
                    unit: "kg*m²",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => {
                        let el: InputElement | undefined = getElementWithPagekey("page8", "Anzahl_Pumpen");
                        let elnum = (el !== undefined ? Number(el.getValue()) : 0);
                        if(elnum > 2)
                            return true;
                        else
                            return false;
                    }
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Steifigkeit_Pumpe_3",
                    label: tl("HydraulicspumpStiffness3"),
                    value: undefined,
                    unit: "Nm/rad",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => {
                        let el: InputElement | undefined = getElementWithPagekey("page8", "Anzahl_Pumpen");
                        let elnum = (el !== undefined ? Number(el.getValue()) : 0);
                        if(elnum > 2)
                            return true;
                        else
                            return false;
                    }
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Masseträgheitsmoment_Pumpe_4",
                    label: tl("HydraulicspumpMomentsOfInertia4"),
                    value: undefined,
                    unit: "kg*m²",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => {
                        let el: InputElement | undefined = getElementWithPagekey("page8", "Anzahl_Pumpen");
                        let elnum = (el !== undefined ? Number(el.getValue()) : 0);
                        if(elnum > 3)
                            return true;
                        else
                            return false;
                    }
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Steifigkeit_Pumpe_4",
                    label: tl("HydraulicspumpStiffness4"),
                    value: undefined,
                    unit: "Nm/rad",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => {
                        let el: InputElement | undefined = getElementWithPagekey("page8", "Anzahl_Pumpen");
                        let elnum = (el !== undefined ? Number(el.getValue()) : 0);
                        if(elnum > 3)
                            return true;
                        else
                            return false;
                    }
                }),

            ],
            nextResolver: () => { 
                let nextPage: string = "page9";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page9",
            name: "Kenndaten_Betriebspunkt_Hydraulikmotor",
            label: tl("OperationalPointHydraulics"),
            url: "www.ktrpage.com/page9",
            isSelected: false,
            category: tl('CategoryDriven'),
            elements: [
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Leistung",
                    label: tl("OperationalPointPower"),
                    value: undefined,
                    unit: "kW",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Drehmoment",
                    label: tl("OperationalPointTorque"),
                    value: undefined,
                    unit: "Nm",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Drehzahl",
                    label: tl("OperationalPointSpeed"),
                    value: undefined,
                    unit: "1/min",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
            ],
            nextResolver: () => { 
                let nextPage: string = "page10";
                return nextPage;
            }
        }),


        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page10",
            name: "Wellentyp",
            label: tl("ShaftType"),
            url: "www.ktrpage.com/page10",
            isSelected: false,
            category: tl('CategoryCoupling'),
            elements: [
                new InputOptional({
                    type: InputType.Optional,
                    name: "Wellentyp",
                    label: tl("ShaftTypeBoreType"),
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options: [tl("ShaftTypeCylindrical"), tl("ShaftTypeTaper"), tl("ShaftTypeProfile")]
                }),
            ],
            nextResolver: () => { 
                let nextPage: string = "";
                let el: InputElement | undefined = getElementWithPagekey("page10", "Wellentyp");
                if(el !== undefined) {
                    if(el.value === 0) nextPage = "page11"
                    else if(el.value === 1) nextPage = "page15"
                    else if(el.value === 2) nextPage = "page16"
                }
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page11",
            name: "Wellendetails_Zylindrisch",
            label: tl("BoreCylindrical"),
            url: "www.ktrpage.com/page11",
            isSelected: false,
            category: tl('CategoryCoupling'),
            elements: [
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Nenndurchmesser",
                    label: tl("BoreCylindricalNominalDiameter"),
                    value: undefined,
                    unit: "mm",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Nutzbare_Länge",
                    label: tl("BoreCylindricalLength"),
                    value: undefined,
                    unit: "mm",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputValueBoolean({
                    type: InputType.ValueBoolean,
                    name:  "Passfeder",
                    label: tl("BoreCylindricalFeatherKeyway"),
                    value:  false,
                    isMandatory:  true
                }),
                new InputImage({
                    type: InputType.Image,
                    name: "AvailableLengthCylindrical",
                    label: tl("BoreCylindricalImage"),
                    value: "",
                    target: "AvailableLengthCylindrical",         // takes image in public/images/wellen.jpg
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any
                }),

            ],
            nextResolver: () => { 
                let nextPage: string = "";
                let el: InputElement | undefined = getElementWithPagekey("page1", "Kombination");
                if(el !== undefined) {
                    if(el.value === 0) nextPage = "page12"
                    else if(el.value === 1) nextPage = "page14"
                    else if(el.value === 2) nextPage = "page12a"
                    else if(el.value === 3) nextPage = "page14"
                }
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page12",
            name: "Groessee_Flanschanschluss",
            label: tl("SizeFlange"),
            url: "www.ktrpage.com/page12",
            isSelected: false,
            category: tl('CategoryCoupling'),
            elements: [
                new InputOptional({
                    type: InputType.Optional,
                    name: "Groesse_Flanschanschluss",
                    label: tl("SizeFlangeSize"),
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options: ["SAE A","SAE B","SAE C","SAE D","SAE E"]
                }),
            ],
            nextResolver: () => { 
                let nextPage: string = "page13";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page12a",
            name: "Gehäusegrösse",
            label: tl("SizeHousing"),
            url: "www.ktrpage.com/page5",
            isSelected: false,
            category: tl('CategoryCoupling'),
            elements: [
                new InputOptional({
                    type: InputType.Optional,
                    name: "Gehäusegröße",
                    label: tl("SizeHousingSize"),
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Dropdown,
                    options: ["SAE-1", "SAE-2", "SAE-3", "SAE-4", "SAE-5", "SAE-6" ]
                }),
            ],
            nextResolver: () => { 
                let nextPage: string = "page14";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page13",
            name: "Ausfuehrung_Flanschanschluss",
            label: tl("FlangeType"),
            url: "www.ktrpage.com/page13",
            isSelected: false,
            category: tl('CategoryCoupling'),
            elements: [
                new InputOptional({
                    type: InputType.Optional,
                    name: "Ausührung Flanschanschluss",
                    label: tl("FlangeTypeStyle"),
                    value: 0,
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options: [tl("FlangeTypeHoles2"), tl("FlangeTypeHoles4")],
                    // if SAE E selected only 4-Loch possible
                    isValid: () => { 
                        let ret: boolean = true;
                        let page12SizeFlange: any = getElementWithPagekey("page12", "Groesse_Flanschanschluss");
                        if(page12SizeFlange === undefined)
                            return false;

                        if(page12SizeFlange.value === "SAE E") {
                            let me: any = getElementWithPagekey("page13", "Ausfuehrung_Flanschanschluss");
                            if(me === undefined)
                                return false;
    
                            me.value = tl("FlangeTypeHoles4");
                        }
                        return ret;
                    },
                }),
            ],
            nextResolver: () => { 
                let nextPage: string = "page14";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page14",
            name: "Sonstige_Anforderungen",
            label: tl("OtherRequirements"),
            url: "www.ktrpage.com/page14",
            isSelected: false,
            category: tl('CategoryCoupling'),
            elements: [
                new InputValueBoolean({
                    type: InputType.ValueBoolean,
                    name:  "ATEX",
                    label: tl("OtherRequirementsATEX"),
                    value:  false,
                    isMandatory:  false,
                }),
                new InputValueBoolean({
                    type: InputType.ValueBoolean,
                    name:  "Wuchtung",
                    label: tl("OtherRequirementsBalancing"),
                    value:  false,
                    isMandatory:  false,
                }),
                new InputValueBoolean({
                    type: InputType.ValueBoolean,
                    name:  "Verbindung_Pumpen_und_Motorgehaeuse_von_KTR",
                    label: tl("OtherRequirementsConnPumpHousing"),
                    value:  false,
                    isMandatory:  false,
                }),
                new InputValueBoolean({
                    type: InputType.ValueBoolean,
                    name:  "Erstmusterprüfbereicht",
                    label: tl("OtherRequirementsCertificate"),
                    value:  false,
                    isMandatory:  false,
                }),
                new InputValueBoolean({
                    type: InputType.ValueBoolean,
                    name:  "Materialzeugnis",
                    label: tl("OtherRequirementsCertificateMaterial"),
                    value:  false,
                    isMandatory:  false,
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "WuchtungDetail",
                    label: tl("OtherRequirementsBalancingDetails"),
                    value: "",
                    isMandatory:  false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputValueBoolean | undefined = getElementWithPagekey("page14", "Wuchtung") as InputValueBoolean;
                        if(el !== undefined) {
                            if(el.value === true)   // only visible when "Wuchtung" is true
                                return true;
                            else
                                return false;
                        }
                        else {
                            return false;
                        }
                    }
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Sonstiges",
                    label: tl("OtherRequirementsOther"),
                    value: "",
                    isMandatory:  false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),

            ],
            nextResolver: () => { 
                let nextPage: string = "page99";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page15",
            name: "Wellendetails_Kegel",
            label: tl("BoreTaper"),
            url: "www.ktrpage.com/page13",
            isSelected: false,
            category: tl('CategoryCoupling'),
            elements: [
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "d1",
                    label: tl("BoreTaperD1"),
                    value: undefined,
                    unit: "mm",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "d2",
                    label: tl("BoreTaperD2"),
                    value: undefined,
                    unit: "mm",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "l1",
                    label: tl("BoreTaperL1"),
                    value: undefined,
                    unit: "mm",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "l2",
                    label: tl("BoreTaperL2"),
                    value: undefined,
                    unit: "mm",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputValueBoolean({
                    type: InputType.ValueBoolean,
                    name:  "Passfeder",
                    label: tl("BoreTaperKeyway"),
                    value:  false,
                    isMandatory:  true
                }),
                new InputOptional({
                    type: InputType.Optional,
                    name: "Kegel",
                    label: tl("BoreTaperType"),
                    value: 0,
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options: ["1:5", "1:8"]
                }),
                // Typer 1:5
                new InputImage({
                    type: InputType.Image,
                    name: "Taper15",
                    label: tl("BoreTaperType15"),
                    value: "",
                    target: "BowexTaper15",         // takes image in public/images/wellen.jpg
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any,
                    isVisible: () => {
                        let el: InputElement | undefined = getElementWithPagekey("page15", "Kegel");
                        if(el !== undefined) {
                            if(el.value === 0)
                                return true;
                            else
                                return false;
                        }
                        else {
                            return false;
                        }
                    }
                }),
                // Typer 1:8
                new InputImage({
                    type: InputType.Image,
                    name: "Taper18",
                    label: tl("BoreTaperType18"),
                    value: "",
                    target: "BowexTaper18_110",         // takes image in public/images/wellen.jpg
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any,
                    isVisible: () => {
                        let el: InputElement | undefined = getElementWithPagekey("page15", "Kegel");
                        if(el !== undefined) {
                            if(el.value === 1)
                                return true;
                            else
                                return false;
                        }
                        else {
                            return false;
                        }
                    }
                }),
            ],
            nextResolver: () => { 
                let nextPage: string = "";
                let el: InputElement | undefined = getElementWithPagekey("page1", "Kombination");
                if(el !== undefined) {
                    if(el.value === 0) nextPage = "page12"
                    else if(el.value === 1) nextPage = "page14"
                    else if(el.value === 2) nextPage = "page12a"
                    else if(el.value === 3) nextPage = "page14"
                }
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page16",
            name: "Wellendetails_Profil",
            label: tl("BoreProfile"),
            url: "www.ktrpage.com/page14",
            isSelected:  false,
            category: tl('CategoryCoupling'),
            elements: [
                new InputOptional({
                    type: InputType.Optional,
                    name: "Profilnorm",
                    label: tl("BoreProfileNorm"),
                    value: 0,
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options: ["DIN 5480","DIN 5482","DIN ISO 14", "ANSI B92.1"],
                    onAction: () => {
                        let el1: InputOptional | undefined = (getElementWithPagekey("page16", "Profilnorm") as InputOptional);
                        let el: InputOptional | undefined = (getElementWithPagekey("page16", "Profilcode") as InputOptional);
                        if(el === undefined) return;
                        el.options =  macroGenerateProfileCodes(el1.getValue() as string);
                    }
                }),
                new InputOptional({
                    type: InputType.Optional,
                    name: "Profilcode",
                    label: tl("BoreProfileCode"),
                    value: 0,
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Dropdown,
                    options: []
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Nutzbare_Länge",
                    label: tl("BoreProfileLength"),
                    value: undefined,
                    unit: "mm",
                    isMandatory: true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputImage({
                    type: InputType.Image,
                    name: "AvailableLengthSpline",
                    label: tl("BoreProfileImage"),
                    value: "",
                    target: "AvailableLengthSpline",         // takes image in public/images/wellen.jpg
                    isMandatory: false,
                    componentname: "",
                    uiElementHint:UIElementHint.Any,
                }),
            ],
            // page initialization
            onPageLoad: () => { 
                let el1: InputOptional | undefined = (getElementWithPagekey("page16", "Profilnorm") as InputOptional);
                let el: InputOptional | undefined = (getElementWithPagekey("page16", "Profilcode") as InputOptional);
                if(el === undefined) return;
                el.options =  macroGenerateProfileCodes(el1.getValue() as string);

                return true;
            },
            nextResolver: () => { 
                let nextPage: string = "";
                let el: InputElement | undefined = getElementWithPagekey("page1", "Kombination");
                if(el !== undefined) {
                    if(el.value === 0) nextPage = "page12"
                    else if(el.value === 1) nextPage = "page14"
                    else if(el.value === 2) nextPage = "page12a"
                    else if(el.value === 3) nextPage = "page14"
                }
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page17",
            name: "Daten_Wasserpumpe",
            label: tl("WaterpumpData"),
            url: "www.ktrpage.com/page17",
            isSelected: false,
            category: tl('CategoryDriven'),
            elements: [
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Hersteller",
                    label: tl("WaterpumpDataManufacturer"),
                    value: "",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Typ",
                    label: tl("WaterpumpDataType"),
                    value: "",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputValueBoolean({
                    type: InputType.ValueBoolean,
                    name:  "Weitere_Antriebe_Riementrieb",
                    label: tl("WaterpumpDataAdditionalDrives"),
                    value:  false,
                    isMandatory:  false
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Masseträgheitsmoment",
                    label: tl("WaterpumpDataMomentOfInertia"),
                    value: undefined,
                    unit: "kg*m²",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Steifigkeit",
                    label: tl("WaterpumpDataStiffness"),
                    value: undefined,
                    unit: "Nm/rad",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "TypNebenantrieb",
                    label: tl("WaterpumpDataTypeSecondaryDrive"),
                    value: "",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => {
                        let el: InputElement | undefined = getElementWithPagekey("page17", "Weitere_Antriebe_Riementrieb");
                        let val = (el !== undefined ? Boolean(el.getValue()) : false);
                        if(val === true)
                            return true;
                        else
                            return false;
                    }
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Masseträgheitsmoment Zusatzabtrieb",
                    label: tl("WaterpumpDataMomentOfInertiaAdditionalDrive"),
                    value: undefined,
                    unit: "kg*m²",
                    isMandatory:  false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => {
                        let el: InputElement | undefined = getElementWithPagekey("page17", "Weitere_Antriebe_Riementrieb");
                        let val = (el !== undefined ? Boolean(el.getValue()) : false);
                        if(val === true)
                            return true;
                        else
                            return false;
                    }
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Steifigkeit Zusatzabtrieb",
                    label: tl("WaterpumpDataStiffnessAdditionalDrive"),
                    value: undefined,
                    unit: "Nm/rad",
                    isMandatory:  false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => {
                        let el: InputElement | undefined = getElementWithPagekey("page17", "Weitere_Antriebe_Riementrieb");
                        let val = (el !== undefined ? Boolean(el.getValue()) : false);
                        if(val === true)
                            return true;
                        else
                            return false;
                    }
                }),
            ],
            nextResolver: () => { 
                let nextPage: string = "page9";   // Kenndaten im Betriebspunkt für Hydraulikpumpe und Wasserpumpe
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page18",
            name: "Daten_Generator",
            label: tl("GeneratorData"),
            url: "www.ktrpage.com/page18",
            isSelected: false,
            category: tl('CategoryDriven'),
            elements: [
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Hersteller",
                    label: tl("GeneratorDataManufacturer"),
                    value: "",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Typ",
                    label: tl("GeneratorDataType"),
                    value: "",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Massenträgheitsmoment",
                    label: tl("GeneratorDataMomentOfInertia"),
                    value: undefined,
                    unit: "kg*m²",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Steifigkeit",
                    label: tl("GeneratorDataStiffness"),
                    value: undefined,
                    unit: "Nm/rad",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
            ],
            nextResolver: () => { 
                let nextPage: string = "page19";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page19",
            name: "Kenndaten_Betriebspunkt_Generator",
            label: tl("OperationalPointGenerator"),
            url: "www.ktrpage.com/page19",
            isSelected: false,
            category: tl('CategoryDriven'),
            elements: [
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Leistung",
                    label: tl("OperationalPointGeneratorPower"),
                    value: undefined,
                    unit: "kW",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Drehmoment",
                    label: tl("OperationalPointGeneratorTorque"),
                    value: undefined,
                    unit: "Nm",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputOptional({
                    type: InputType.Optional,
                    name: "Betriebsdrehzahl",
                    label: tl("OperationalPointGeneratorSpeed"),
                    value: 0,
                    unit: "1/min",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options: ["1500","1800"]
                }),

            ],
            nextResolver: () => { 
                let nextPage: string = "page10";    // goto Wellentyp
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page20",
            name: "Verdichter",
            label: tl("CompressorData"),
            url: "www.ktrpage.com/page20",
            isSelected: false,
            category: tl('CategoryDriven'),
            elements: [
                new InputOptional({
                    type: InputType.Optional,
                    name: "Typ",
                    label: tl("CompressorDataType"),
                    value: 0,
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options: [tl("CompressorDataPiston"), tl("CompressorDataScrew")]
                }),
            ],
            nextResolver: () => { 
                let nextPage: string = "";
                let el: InputElement | undefined = getElementWithPagekey("page20", "Typ");
                if(el !== undefined) {
                    if(el.value === 0) nextPage = "page21"
                    else if(el.value === 1) nextPage = "page23"
                }
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page21",
            name: "Daten_Hubkolbenkompressor",
            label: tl("CompressorDataPistonData"),
            url: "www.ktrpage.com/page21",
            isSelected: false,
            category: tl('CategoryDriven'),
            elements: [
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Hersteller",
                    label: tl("CompressorDataPistonDataManufacturer"),
                    value: "",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Typ",
                    label: tl("CompressorDataPistonDataType"),
                    value: "",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),

            ],
            nextResolver: () => { 
                let nextPage: string = "page22";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page22",
            name: "Kenndaten_Betriebspunkt_Hubkolbenkompressor",
            label: tl("OperationalPointCompressorPiston"),
            url: "www.ktrpage.com/page22",
            isSelected:  false,
            category: tl('CategoryDriven'),
            elements: [
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Massenträgheitsmoment",
                    label: tl("OperationalPointCompressorPistonMomentOfInertia"),
                    value: undefined,
                    unit: "kg*m²",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Steifigkeit",
                    label: tl("OperationalPointCompressorPistonStiffness"),
                    value: undefined,
                    unit: "Nm/rad",
                    isMandatory:  false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                /*
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Upload_Massenersatzsystem",
                    label: "Upload Massenersatzsystem",
                    value: "",
                    isMandatory:  false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputElement | undefined = getElementWithPagekey("page22", "Steifigkeit");
                        if(el !== undefined) {
                            if((el.value === "") || (el.value === undefined))
                                return false;
                            else
                                return true;
                        }
                        else
                            return false;
                    }
                }),
                */
                new InputUpload({
                    type: InputType.Upload,
                    name: "Upload_Massenersatzsystem",
                    label: tl("OperationalPointCompressorPistonMassReplacementUpload"),
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputElement | undefined = getElementWithPagekey("page22", "Steifigkeit");
                        if(el !== undefined) {
                            if((el.value === "") || (el.value === undefined))
                                return false;
                            else
                                return true;
                        }
                        else
                            return false;
                    }
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Zylinderanzahl",
                    label: tl("OperationalPointCompressorPistonNumCylinder"),
                    value: undefined,
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputOptional({
                    type: InputType.Optional,
                    name: "Zylinderanordnung",
                    label: tl("OperationalPointCompressorPiston"),
                    value: 0,
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Selectbox,
                    options: [
                        tl("OperationalPointCompressorPistonVertical"), 
                        tl("OperationalPointCompressorPistonHorizontal"),
                        tl("OperationalPointCompressorPistonV"), 
                        tl("OperationalPointCompressorPistonW"), 
                        tl("OperationalPointCompressorPistonL")
                    ]
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Verdichtungsstufen",
                    label: tl("OperationalPointCompressorPistonCompressionLevel"),
                    value: undefined,
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                /*
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Upload_Tangentialkraftdiagramm",
                    label: "Upload Tangentialkraftdiagramm",
                    value: "",
                    isMandatory:  false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                }),
                */
                new InputUpload({
                    type: InputType.Upload,
                    name: "Upload_Tangentialkraftdiagramm",
                    label: tl("OperationalPointCompressorPistonUploadTangential"),
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                }),
    
            ],
            nextResolver: () => { 
                let nextPage: string = "page10";   // Wellentyp
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page23",
            name: "Daten_Schraubenkompressor",
            label: tl("CompressorDataScrewData"),
            url: "www.ktrpage.com/page23",
            isSelected: false,
            category: tl('CategoryDriven'),
            elements: [
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Hersteller",
                    label: tl("CompressorDataScrewDataManufacturer"),
                    value: "",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Typ",
                    label: tl("CompressorDataScrewDataType"),
                    value: "",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputValueBoolean({
                    type: InputType.ValueBoolean,
                    name:  "Getriebestufe_vorhanden",
                    label: tl("CompressorDataScrewDataGearbox"),
                    value:  false,
                    isMandatory:  false,
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Übersetzung i",
                    label: tl("CompressorDataScrewDataRatio"),
                    value: "",
                    isMandatory:  false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputElement | undefined = getElementWithPagekey("page23", "Getriebestufe_vorhanden");
                        if(el !== undefined) {
                            if(el.value === true)
                                return true;
                            else
                                return false;
                        }
                        else
                            return false;
                    }
                }),

            ],
            nextResolver: () => { 
                let nextPage: string = "page24";
                return nextPage;
            }
        }),

        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page24",
            name: "Kenndaten_Betriebspunkt_Schraubenkompressor",
            label: tl("OperationalPointCompressorScrew"),
            url: "www.ktrpage.com/page24",
            isSelected: false,
            category: tl('CategoryDriven'),
            elements: [
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Massenträgheitsmoment",
                    label: tl("OperationalPointCompressorScrewMomentOfInertia"),
                    value: undefined,
                    unit: "kg*m²",
                    isMandatory:  true,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                new InputSingleValueNumber({
                    type: InputType.ValueNumber,
                    name: "Steifigkeit",
                    label: tl("OperationalPointCompressorScrewStiffness"),
                    value: undefined,
                    unit: "Nm/rad",
                    isMandatory:  false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox
                }),
                /*
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name: "Upload_Massenersatzsystem",
                    label: "Upload Massenersatzsystem",
                    value: "",
                    isMandatory:  false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputElement | undefined = getElementWithPagekey("page24", "Steifigkeit");
                        if(el !== undefined) {
                            if(el.value === "")
                                return false;
                            else
                                return true;
                        }
                        else
                            return false;
                    }
                }),
                */
                new InputUpload({
                    type: InputType.Upload,
                    name: "Upload_Massenersatzsystem",
                    label: tl("OperationalPointCompressorScrewUpladMassReplacement"),
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                    isVisible: () => { 
                        let el: InputElement | undefined = getElementWithPagekey("page24", "Steifigkeit");
                        if(el !== undefined) {
                            if((el.value === "") || (el.value === undefined))
                                return false;
                            else
                                return true;
                        }
                        else
                            return false;
                    }
                }),
    
            ],
            nextResolver: () => { 
                let nextPage: string = "page10";   // Wellentyp
                return nextPage;
            }
        }),

        // ---------------------------------------------------------------------------------------------------------------
        new Page({
            id: "page99",
            name: "Ergebnis",
            label: tl("Contact"),
            url: "www.ktrpage.com/page99",
            isSelected: false,
            showOverview: true,
            category: tl('CategoryOverview'),
            elements: [
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name:  "Firma",
                    label: tl("ContactCompany"),
                    value:  "",
                    isMandatory:  true,
                    componentname:  "",
                    uiElementHint: UIElementHint.Editbox,
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name:  "Anschrift",
                    label: tl("ContactAdress"),
                    value:  "",
                    isMandatory:  false,
                    componentname:  "",
                    uiElementHint: UIElementHint.Editbox,
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name:  "Name",
                    label: tl("ContactName"),
                    value:  "",
                    isMandatory:  true,
                    componentname:  "",
                    uiElementHint: UIElementHint.Editbox,
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name:  "Telefon",
                    label: tl("ContactTelephone"),
                    value:  "",
                    isMandatory:  false,
                    componentname:  "",
                    uiElementHint: UIElementHint.Editbox,
                }),
                new InputSingleValueString({
                    type: InputType.ValueString,
                    name:  "Mail",
                    label:  tl("ContactMail"),
                    value:  "",
                    isMandatory:  true,
                    componentname:  "",
                    uiElementHint: UIElementHint.Editbox,
                }),
                new InputUpload({
                    type: InputType.Upload,
                    name: "Upload_Otherfiles",
                    label: tl("ContactUploadFiles"),
                    value: "",
                    isMandatory: false,
                    componentname: "",
                    uiElementHint: UIElementHint.Editbox,
                }),
                new InputAction({
                    type: InputType.Action,
                    name: "SendMail",
                    label: tl("ContactSendMail"),
                    value: "",
                    isMandatory:  false,
                    componentname:  "",
                    uiElementHint:  UIElementHint.Button,
                    onAction: () => {
                        let url: string = createMailLink("k.tebroke@ktr.com", "Auslegung für Verbrennungsmotoren");
                        window.location.href = url;
                        //window.open(url);
                    }
                }),
                new InputAction({
                    type: InputType.Action,
                    name: "CreatePDF",
                    label: tl("ContactCreatePDF"),
                    value: "",
                    isMandatory:  false,
                    componentname:  "",
                    uiElementHint:  UIElementHint.Button,
                    onAction: () => {
                        downloadPDFGeneric(flow.label);
                    }
                }),

            ],
            nextResolver: () => { 
                let nextPage: string = "page99";
                return nextPage;
            }
        }),
        // ---------------------------------------------------------------------------------------------------------------

    ]
};

export { flow, globals };
